/* Evalay walnut theme: shared behaviour. Null-safe, idempotent. */
(function () {
  'use strict';

  function menu(scope) {
    scope.querySelectorAll('[data-ev-burger]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('aria-controls'));
        if (!d) return;
        var open = d.classList.toggle('open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Gallery thumbs: click a thumb to swap the framed image. */
  function gallery(scope) {
    scope.querySelectorAll('[data-ev-gallery]').forEach(function (g) {
      if (g.dataset.bound) return; g.dataset.bound = '1';
      var main = g.querySelector('[data-ev-main]');
      var thumbs = g.querySelectorAll('[data-ev-thumb]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          var alt = t.getAttribute('data-alt') || '';
          if (main && src) { main.src = src; main.alt = alt; }
          thumbs.forEach(function (x) { x.classList.remove('on'); });
          t.classList.add('on');
        });
      });
    });
  }

  /* Variant picker (only rendered when a product has more than one variant).
     Resolves the selected option combination to a variant id + price. */
  function variants(scope) {
    scope.querySelectorAll('[data-ev-buy]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var list; try { list = JSON.parse(root.dataset.variants || '[]'); } catch (e) { list = []; }
      if (!list.length) return;
      var money = root.dataset.money || '${{amount}}';
      var idEl = root.querySelector('[data-ev-variant-id]');
      var priceEls = root.querySelectorAll('[data-ev-price]');
      var cta = root.querySelector('[data-ev-cta]');
      var soldOut = root.dataset.soldout || 'Sold out';
      var ctaLabel = root.dataset.cta || 'Add to bag';
      var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-ev-opt]'));

      /* Deposit (pre-order) plan: data-deposits = { variantId: { plan, now, later } } in cents.
         Two radios (data-ev-pay) pick deposit or full. The hidden selling_plan input (data-ev-plan)
         is enabled only when reserving. If the Downpay app embed has rendered its own radios,
         they are clicked too so the app's state matches; its box itself is hidden by CSS. */
      var deposits = {}; try { deposits = JSON.parse(root.dataset.deposits || '{}'); } catch (e) { deposits = {}; }
      var payInputs = Array.prototype.slice.call(root.querySelectorAll('[data-ev-pay]'));
      var planEl = root.querySelector('[data-ev-plan]');
      var dueNow = root.querySelector('[data-ev-due-now]');
      var dueLater = root.querySelector('[data-ev-due-later]');
      var laterRow = root.querySelector('[data-ev-due-later-row]');
      var ctaPrice = root.querySelector('[data-ev-cta-price]');
      var mainPrice = document.querySelector('[data-ev-main-price]');
      var reserveLabel = root.dataset.reserve || 'Reserve now';
      function depositOn() { var c = payInputs.filter(function (i) { return i.checked; })[0]; return !!(c && c.value === 'deposit'); }
      function syncApp(dep) {
        var want = document.getElementById(dep ? 'purchase-option-deposit-input' : 'purchase-option-full');
        if (want && !want.checked) want.click();
        /* The app writes its own selling_plan input into the form; keep only one source of truth. */
        if (want && planEl) planEl.disabled = true;
      }

      function fmt(c) { var a = c / 100; var s = a % 1 === 0 ? a.toFixed(0) : a.toFixed(2); return money.replace(/\{\{\s*amount[^}]*\}\}/, s); }
      function picked() { var o = []; inputs.forEach(function (i) { if (i.checked) o[parseInt(i.dataset.pos, 10) - 1] = i.value; }); return o; }
      function update() {
        inputs.forEach(function (i) { var w = i.closest('.opt'); if (w) w.classList.toggle('on', i.checked); });
        var want = picked();
        var m = list.filter(function (v) { return want.every(function (val, i) { return val == null || v.options[i] === val; }); })[0];
        if (!m) { if (cta) { cta.disabled = true; setLabel(soldOut); } return; }
        if (idEl) idEl.value = m.id;
        priceEls.forEach(function (p) { p.textContent = fmt(m.price); });
        if (mainPrice) mainPrice.textContent = fmt(m.price);
        var d = deposits[m.id]; var dep = !!(d && depositOn());
        if (ctaPrice) ctaPrice.textContent = fmt(dep ? d.now : m.price);
        if (dueNow) dueNow.textContent = fmt(dep ? d.now : m.price);
        if (dueLater) dueLater.textContent = fmt(dep ? d.later : 0);
        if (laterRow) laterRow.hidden = !dep;
        if (planEl) { planEl.value = dep ? d.plan : ''; planEl.disabled = !dep; }
        syncApp(dep);
        payInputs.forEach(function (i) { var w = i.closest('.popt'); if (w) w.classList.toggle('on', i.checked); });
        if (cta) { cta.disabled = !m.available; cta.classList.toggle('reserve', dep && m.available); setLabel(m.available ? (dep ? reserveLabel : ctaLabel) : soldOut); }
      }
      function setLabel(t) { var s = cta && cta.querySelector('[data-ev-cta-text]'); if (s) s.textContent = t; }
      inputs.forEach(function (i) { i.addEventListener('change', update); });
      payInputs.forEach(function (i) { i.addEventListener('change', update); });
      update();
      /* The app embed renders a moment after load: re-sync when its radios show up (up to ~10 s). */
      if (payInputs.length) { var tries = 0; var t = setInterval(function () { tries++; if (document.getElementById('purchase-option-deposit-input') || tries > 40) { clearInterval(t); update(); } }, 250); }
    });
  }

  function boot(s) { var r = s || document; menu(r); gallery(r); variants(r); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  /* Cart: quantity, remove, one upsell. Posts to Shopify's cart API, then reloads. */
  function cartPost(url, body) {
    document.body.classList.add('busy');
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (r.ok) { location.reload(); return; }
        return r.json().then(function (j) {
          document.body.classList.remove('busy');
          var m = document.querySelector('[data-ev-cart-msg]');
          if (m) { m.textContent = j.description || j.message || 'That did not work. Please try again.'; m.hidden = false; }
        });
      })
      .catch(function () { document.body.classList.remove('busy'); });
  }
  document.querySelectorAll('[data-ev-cart-change]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      cartPost('/cart/change.js', { line: Number(el.dataset.line), quantity: Number(el.dataset.qty) });
    });
  });
  document.querySelectorAll('[data-ev-cart-add]').forEach(function (el) {
    el.addEventListener('click', function () {
      cartPost('/cart/add.js', { items: [{ id: Number(el.dataset.evCartAdd), quantity: 1 }] });
    });
  });
  if (document.querySelector('.sticky')) document.body.classList.add('has-cart-bar');

  /* Notify me popup: any .notify-open opens it. Reopens itself after a signup so the thank-you shows. */
  var nf = document.querySelector('[data-ev-notify]');
  if (nf) {
    nf.hidden = false;
    var klForm = nf.getAttribute('data-ev-klaviyo');
    function openNf() {
      /* Klaviyo popup when a form ID is set and Klaviyo's script is on the page; otherwise the built-in form. */
      if (klForm && window._klOnsite && typeof window._klOnsite.push === 'function') {
        window._klOnsite.push(['openForm', klForm]);
        return;
      }
      nf.classList.add('on'); var f = nf.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus(); }, 50);
    }
    function closeNf() { nf.classList.remove('on'); }
    document.querySelectorAll('.notify-open').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openNf(); });
    });
    nf.querySelectorAll('[data-ev-notify-close]').forEach(function (b) { b.addEventListener('click', closeNf); });
    nf.addEventListener('click', function (e) { if (e.target === nf) closeNf(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNf(); });
    if (location.search.indexOf('customer_posted=true') > -1 || nf.querySelector('.err')) { openNf(); if (history.replaceState) history.replaceState(null, '', location.pathname + location.hash); }
  }

  /* Hero slideshow: crossfade customer photos; dots to pick one. Pauses on hover. */
  document.querySelectorAll('[data-ev-slides]').forEach(function (box) {
    var slides = box.querySelectorAll('.slide'), dots = box.querySelectorAll('[data-ev-dot]');
    if (slides.length < 2) return;
    var i = 0, every = Number(box.dataset.every) || 5000, timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, every); }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.dataset.evDot)); start(); }); });
    box.addEventListener('mouseenter', stop); box.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  });

  /* Gift checkbox: save to the cart right away so it survives any path to checkout. */
  var gift = document.querySelector('[data-ev-gift]');
  if (gift) gift.addEventListener('change', function () {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { Gift: gift.checked ? 'Yes' : '' } }) }).catch(function () {});
  });
})();
